import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import axios from "axios";
import { Link } from "react-router-dom";
import logo from "../assets/images/krishnasilver.png";
import aboutImg from "../assets/images/mix-item-2-blue.png";
import Header from "../components/header";
import Footer from "../components/footer";
import { Helmet } from "react-helmet-async";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";

const Home = () => {

    const { executeRecaptcha } = useGoogleReCaptcha();

    const [current, setCurrent] = useState(0);
    const [slides, setSlides] = useState([]);
    const [categories, setCategories] = useState([]);
    const [menuOpen, setMenuOpen] = useState(false);
    const [scrolled, setScrolled] = useState(false);
    const [loading, setLoading] = useState(true);
    const [responseMsg, setResponseMsg] = useState("");
    const [contactInfo, setContactInfo] = useState({});
    const [about, setAbout] = useState({});

    useEffect(() => {

        axios.get("https://kskrishnasilver.com/api/home.php")
            .then(res => {
                setAbout(res.data);
            });

    }, []);

    /* ========================
    SCROLL DETECT
    ======================== */

    useEffect(() => {

        const handleScroll = () => {
            if (window.scrollY > 60) {
                setScrolled(true);
            } else {
                setScrolled(false);
            }
        };

        window.addEventListener("scroll", handleScroll);

        return () => window.removeEventListener("scroll", handleScroll);

    }, []);


    // Preloader timer
    useEffect(() => {
        const timer = setTimeout(() => setLoading(false), 1000);
        return () => clearTimeout(timer);
    }, []);

    useEffect(() => {
        axios
            .get("https://kskrishnasilver.com/api/slider.php")
            .then(res => {
                if (res.data && res.data.length > 0) {
                    const sliderImages = res.data.map(slide => ({
                        image: `https://kskrishnasilver.com/uploads/slider/${slide.image}`,
                        title: slide.title,
                        subtitle: slide.subtitle,
                        link: slide.link
                    }));
                    setSlides(sliderImages);

                }
            })
            .catch(err => console.error("Slider API Error:", err));
    }, []);

    // =========================
    // AUTO SLIDE
    // =========================
    useEffect(() => {

        if (slides.length === 0) return;

        const interval = setInterval(() => {
            setCurrent((prev) => (prev + 1) % slides.length);
        }, 5000); // 3 seconds

        return () => clearInterval(interval);

    }, [slides.length]);


    useEffect(() => {
        axios
            .get("https://kskrishnasilver.com/api/category.php")
            .then((res) => {
                console.log("API Response:", res.data);

                if (Array.isArray(res.data)) {
                    setCategories(res.data);
                } else if (res.data.data) {
                    setCategories(res.data.data);
                } else {
                    console.log("Unexpected format");
                }
            })
            .catch((err) => {
                console.error("Error fetching categories:", err);
            });
    }, []);

    const [formData, setFormData] = useState({
        name: "",
        email: "",
        phone: "",
        category: "",
        message: ""
    });

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!executeRecaptcha) {
            setResponseMsg("Captcha not ready");
            return;
        }

        try {

            const token = await executeRecaptcha("contact_form");

            const res = await axios.post(
                "https://kskrishnasilver.com/api/add_inquiry.php",
                {
                    ...formData,
                    recaptchaToken: token
                },
                {
                    headers: {
                        "Content-Type": "application/json"
                    }
                }
            );

            setResponseMsg(res.data.message);

            setFormData({
                name: "",
                email: "",
                phone: "",
                category: "",
                message: ""
            });

        } catch (err) {
            setResponseMsg("Something went wrong");
        }
    };

    useEffect(() => {

        axios
            .get("https://kskrishnasilver.com/api/contact.php")
            .then((res) => {
                setContactInfo(res.data);
            })
            .catch((err) => console.log(err));

    }, []);

    return (
        <>
            {loading && (
                <div className="loader-wrapper">
                    <div className="ring-loader"></div>
                </div>
            )}
            <div className="main-container">
                <Header />

                <Helmet>
                    <title>
                        {`Home | Krishna Silver | ${process.env.REACT_APP_PHONE}`}
                    </title>
                </Helmet>
                {/* HERO SECTION WITH ANIMATED SLIDER */}
                <section id="home" className="hero">

                    <div
                        className="hero-slider"
                        style={{ transform: `translateX(-${current * 100}%)` }}
                    >
                        {slides.map((slide, index) => (
                            <img
                                key={index}
                                src={slide.image}
                                className="hero-slide"
                                alt="slider"
                            />
                        ))}
                    </div>

                    <div className="hero-overlay"></div>

                    <div className="hero-content">
                        <h1>{slides[current]?.title || "Krishna Silver"}</h1>
                        <p>{slides[current]?.subtitle || "Premium Traditional Silver Jewellery Collection"}</p>
                        <Link to={slides[current]?.link || "#"} className="hero-btn">Explore Collection</Link>
                    </div>

                    {/* Arrows */}

                    <button
                        className="hero-arrow left"
                        onClick={() =>
                            setCurrent((prev) => (prev - 1 + slides.length) % slides.length)
                        }
                    >
                        ‹
                    </button>

                    <button
                        className="hero-arrow right"
                        onClick={() =>
                            setCurrent((prev) => (prev + 1) % slides.length)
                        }
                    >
                        ›
                    </button>

                    {/* Dots */}

                    <div className="hero-dots">
                        {slides.map((_, index) => (
                            <span
                                key={index}
                                className={current === index ? "dot active" : "dot"}
                                onClick={() => setCurrent(index)}
                            ></span>
                        ))}
                    </div>

                </section>

                {/* ABOUT SECTION */}
                <section className="about">
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-lg-6 about-left">

                                <span className="subtitle">ABOUT US</span>

                                <h2>
                                    Welcome To <span>Krishna Silver</span>
                                </h2>

                                {/* <p>
                                    "Krishna Silver specializes in crafting traditional Silver Jewellery, including iconic pieces like <strong>Bombay Fancy Payal, Chabi Guchha, Milan Chain Full Belt, Milan Chain Half Belt, Gop Chain Belt, Kandora, and Thumka Juda.</strong> With a fully integrated production facility and a commitment to innovative processes, we introduce over 50 new designs monthly. This dedication ensures value for wholesalers, retailers, and consumers alike, all while maintaining unwavering standards of quality and purity. Continual enhancements in management, product range, and business strategies underscore our pursuit of excellence, propelling us toward sustained success on a solid foundation of professionalism."
                                </p> */}

                                <div dangerouslySetInnerHTML={{ __html: about.content }}></div>

                                {/* <button className="about-btn">Explore More</button> */}

                            </div>


                            <div className="col-lg-6 about-right">

                                <div className="about-image-box">
                                    <img src={about.image} alt="Krishna Silver Jewellery" className="about-main-img" />

                                    <div className="image-bg-shape"></div>

                                </div>

                            </div>
                        </div>
                    </div>
                </section>

                {/* Collections */}
                <section className="categories">
                    <div className="container">
                        <h2 className="section-title">Our Collections</h2>
                        <p className="section-subtitle">We have an extensive collection available for you.</p>
                        <div className="category-grid">

                            {categories.map((item, index) => (

                                <div className="category-card" key={index}>

                                    <div className="card-inner">

                                        <img
                                            src={`https://kskrishnasilver.com/uploads/category/${item.img}`}
                                            alt={item.name}
                                        />

                                        <div className="category-overlay">

                                            <h3>{item.name}</h3>

                                            <Link to={`/collection/${item.slug}`}>
                                                <button className="view-btn">View Collection</button>
                                            </Link>

                                        </div>

                                    </div>

                                </div>

                            ))}

                        </div>
                    </div>
                </section>

                {/* CONTACT */}
                <section className="contact-section">
                    <div className="container">
                        <div className="contact-container">

                            {/* LEFT PANEL */}
                            <div className="contact-left">

                                <h2>Contact Details</h2>

                                <p>
                                    Connect with India's leading silver jewelry manufacturer for premium
                                    bulk requirements and custom branding.
                                </p>

                                <div className="contact-info">

                                    <div className="info-item">
                                        <i className="fa-solid fa-phone"></i>
                                        <div>
                                            <span>CALL</span>
                                            <p><Link to={`tel:+91${contactInfo.mobile}`}> +91 {contactInfo.mobile} </Link></p>
                                        </div>
                                    </div>

                                    <div className="info-item">
                                        <i className="fa-solid fa-envelope"></i>
                                        <div>
                                            <span>EMAIL ADDRESS</span>
                                            <p><Link to={`mailto:${contactInfo.email}`}> {contactInfo.email} </Link></p>
                                        </div>
                                    </div>

                                    <div className="info-item">
                                        <i className="fa-solid fa-location-dot"></i>
                                        <div>
                                            <span>ADDRESS</span>
                                            <p><Link to={contactInfo.map_link} target="_blank"> {contactInfo.address} </Link></p>
                                        </div>
                                    </div>

                                    <div className="info-item">
                                        <i className="fa-solid fa-clock"></i>
                                        <div>
                                            <span>WORKING HOURS</span>
                                            <p>{contactInfo.working_hours}</p>
                                        </div>
                                    </div>

                                </div>


                            </div>

                            {/* RIGHT PANEL */}
                            <div className="contact-right">

                                <h3>Keep In Touch With Us</h3>

                                <form className="inquiry-form" onSubmit={handleSubmit}>

                                    <input
                                        type="text"
                                        name="name"
                                        placeholder="YOUR NAME"
                                        value={formData.name}
                                        onChange={handleChange}
                                        required
                                    />

                                    <input
                                        type="email"
                                        name="email"
                                        placeholder="EMAIL ADDRESS"
                                        value={formData.email}
                                        onChange={handleChange}
                                    />

                                    <input
                                        type="text"
                                        name="phone"
                                        placeholder="PHONE NUMBER"
                                        value={formData.phone}
                                        onChange={handleChange}
                                        required
                                    />

                                    <select
                                        name="category"
                                        value={formData.category}
                                        onChange={handleChange}
                                    >
                                        <option value="">SELECT</option>
                                        {categories.map((cat, index) => (
                                            <option key={index} value={cat.name}>
                                                {cat.name}
                                            </option>
                                        ))}
                                    </select>

                                    <textarea
                                        name="message"
                                        rows="4"
                                        placeholder="ENTER YOUR MESSAGE"
                                        value={formData.message}
                                        onChange={handleChange}
                                    />

                                    <button type="submit">SUBMIT INQUIRY</button>
                                    {responseMsg && (
                                        <p style={{ color: "green" }}>
                                            {responseMsg}
                                        </p>
                                    )}
                                </form>

                            </div>

                        </div>
                    </div>
                </section>

                <Footer />
            </div>
        </>
    );
};

export default Home;